import type { TextContent } from "./contentItemSchemas";
import { CONTENT_ITEM_KEYS } from "@/constants/contentItemKeys";
import { isRecord } from "./shared";
import {
  parseWithRecord,
  parseTextContentFromFields,
  textContentFieldsSchema,
} from "./schemas";

export const parseTextContent = (
  item: unknown,
  formLabel?: string,
): TextContent => {
  const parsed = parseWithRecord(item, textContentFieldsSchema);
  return parseTextContentFromFields(parsed, formLabel);
};

export const parseOptionalTextContent = (
  item: unknown,
): TextContent | undefined => {
  if (item == null) return undefined;
  const record = isRecord(item) ? item : {};
  if (
    record[CONTENT_ITEM_KEYS.TEXT] === undefined &&
    record[CONTENT_ITEM_KEYS.CONTENT_FROM] === undefined
  )
    return undefined;
  return parseTextContent(item);
};
